<section class="landing-inversores__faq">
  <div class="landing-inversores__container landing-inversores__faq-inner">
    <h2 class="landing-inversores__section-title">Resuelve todas tus dudas con un experto</h2>

    <div class="landing-inversores__accordion">
      <div class="landing-inversores__accordion-item" *ngFor="let f of faqs; let i = index">
        <h3 class="landing-inversores__accordion-header">
          <button
            type="button"
            class="landing-inversores__accordion-trigger"
            [attr.aria-expanded]="openIndex === i"
            [attr.aria-controls]="'landing-inversores-faq-panel-' + i"
            [id]="'landing-inversores-faq-trigger-' + i"
            (click)="toggle(i)"
          >
            <span>{{ f.q }}</span>
            <landing-inversores-icon
              name="chevron-down"
              class="landing-inversores__accordion-chevron"
              [class.landing-inversores__accordion-chevron--open]="openIndex === i"
            ></landing-inversores-icon>
          </button>
        </h3>
        <div
          class="landing-inversores__accordion-panel"
          [id]="'landing-inversores-faq-panel-' + i"
          role="region"
          [attr.aria-labelledby]="'landing-inversores-faq-trigger-' + i"
          *ngIf="openIndex === i"
        >
          <p>{{ f.a }}</p>
        </div>
      </div>
    </div>
  </div>
</section>
